module.exports = __webpack_public_path__ + "img/sec_right_white.c2ae8567.svg";